import { fieldState, getLinks, groupFormEnabled, operatorVisible, useSite } from "@/lib/content";
import { useSeo } from "@/lib/seo";
import { t } from "@/lib/i18n";
import PageIntro from "@/components/PageIntro";
import Reveal from "@/components/Reveal";
import ContactLinks from "@/components/ContactLinks";
import GroupForm from "@/components/GroupForm";
import { Pending, UnverifiedTag } from "@/components/Pending";

function Operator({ content, isPreview }) {
  const rows = Object.entries(content?.operator || {}).map(([k, f]) => [k, fieldState(f, isPreview)]).filter(([, s]) => s.show);
  return (
    <section id="isletmeci" className="safe-x max-w-7xl mx-auto pb-24 scroll-mt-28" data-testid="operator-section">
      <Reveal className="rounded-3xl border border-line bg-cream-2 p-6 sm:p-10">
        <h2 className="text-3xl font-semibold text-forest mb-6">{t("iletisim.operatorTitle")}</h2>
        <dl className="grid gap-5 sm:grid-cols-2">
          {rows.map(([k, s]) => (
            <div key={k} data-testid={`operator-${k}`}>
              <dt className="text-sm font-semibold text-wood">{t(`iletisim.operator.${k}`)}</dt>
              <dd className="mt-1 text-ink">
                {s.usable ? <span className="inline-flex flex-wrap gap-2 items-center">{s.value}{!s.verified && <UnverifiedTag />}</span> : <Pending />}
              </dd>
            </div>
          ))}
        </dl>
      </Reveal>
    </section>
  );
}

export default function Iletisim() {
  useSeo("iletisim");
  const { content, isPreview } = useSite();
  const links = getLinks(content, isPreview);
  const showForm = groupFormEnabled(content);

  return (
    <div data-testid="iletisim-page">
      <PageIntro eyebrow={t("iletisim.eyebrow")} title={t("iletisim.title")} text={t("iletisim.text")} testId="iletisim-intro" />
      <section className="safe-x max-w-7xl mx-auto pb-20">
        <Reveal><ContactLinks links={links} isPreview={isPreview} /></Reveal>
      </section>
      {showForm && (
        <section className="safe-x max-w-4xl mx-auto pb-24" data-testid="group-form-section">
          <Reveal><GroupForm whatsapp={links.whatsapp} /></Reveal>
        </section>
      )}
      {operatorVisible(content, isPreview) && <Operator content={content} isPreview={isPreview} />}
    </div>
  );
}
